import { IUserCredentials } from './IUserCredentials';
import { ILoginUser } from './ILoginUser';

export interface IForgotPassword extends IUserCredentials {
  supervisorDetails: ILoginUser;
  userDetails: ILoginUser;
  activity: ForgotPasswordActivityTypes;
}

export interface IForgotPasswordUserResponse {
  displayName: string;
  allowedForBarcodeAuthentication: boolean;
  securityIdentifier: {
    userName: string;
  };
}

export enum ForgotPasswordActivityTypes {
  ValidateSupervisorCredentials = 'ValidateSupervisorCredentials',
  AuthorizedChangePassword = 'AuthorizedChangePassword',
}
